import { RadialWheel } from './radialwheel';
import { AMMO_META, type AmmoId } from '../game/weapons';

// The hold-R AMMO-TYPE wheel, for guns that take more than one ammo (e.g. 5.56 regular / explosive). Mirrors the
// build wheel: hold R to open (the pointer is freed), hover a slice, RELEASE R (or click a slice) to pick it. Picking
// sets the weapon's selected ammo + triggers a reload. Guns with a single ammo type never open this (tap R reloads).
export class AmmoWheel extends RadialWheel<AmmoId, never> {
  onPick: ((ammo: AmmoId) => void) | null = null;

  constructor(options: AmmoId[], active: AmmoId) {
    super({
      segments: options.map((id) => ({ key: id, label: AMMO_META[id].name.replace(/ /, '\n') })),
      activeSeg: active,
      hubFallbackLabel: 'AMMO',
      onPointerCommit: () => { this.commitSelection(); this.hide(); }, // click a slice -> pick + close (hide fires onHide -> relock)
    });
  }

  // Apply the hovered slice (release-to-select or click). No-op if nothing is hovered.
  commitSelection(): void { this.commit({ onSeg: (k) => this.onPick?.(k) }); }
}
